export default __webpack_public_path__ + "static/media/Freebooter's Bracers of the Primeval.a2c94e2a.jpg";